<template>
    <CompassTagInteractive
        :modelValue="type"
        class="listing-table-actions__filters-tag"
        color="gray"
        @tag-remove="handleRemoveFilter"
    >
        <template slot="default">
            <div class="filters-tag__label" @click="handleClickOnTag">
                <span class="typographies-paragraph-medium-bold">
                    {{ `${label} :` }}
                </span>
                <span class="typographies-paragraph-medium-regular">
                    {{ valuesHumanized }}
                </span>
            </div>
        </template>
    </CompassTagInteractive>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        valuesHumanized: {
            type: String,
            required: true,
        },
    },
    methods: {
        handleClickOnTag() {
            this.$emit('clickOnTag');
        },
        handleRemoveFilter() {
            this.$emit('removeFilter');
        },
    },
};
</script>

<style lang="scss" scoped>
.listing-table-actions__filters-tag {
    cursor: pointer;
    .filters-tag__label {
        max-width: 220px;
        text-overflow: ellipsis;
        overflow-x: hidden;
        white-space: nowrap;
    }
}
</style>
